import { render, staticRenderFns } from "./SuspendedOrder.vue?vue&type=template&id=5343e205"
import script from "./SuspendedOrder.vue?vue&type=script&lang=js"
export * from "./SuspendedOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports